import React from 'react';

const Contactus = () => {
  return (
    <div>
      {/* Breadcumb Section */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: `url('/assets/img/bg/breadcumb-bg.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Contact Us</h1>
            <ul className="breadcumb-menu">
              <li><a href="/">Home</a></li>
              <li>Contact Us</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="space">
        <div className="container">
          <div className="row gy-4">
            {/* Contact Info Box */}
            <div className="col-xl-5">
              <div className="contact-infobox smoke-bg">
                <div className="title-area">
                  <span className="sub-title">Work With Us</span>
                  <h3 className="sec-title">Contact Information</h3>
                  <p className="sec-text">
                    Thank you for your interest in Attach Web Agency. We're excited to hear from you and discuss...
                  </p>
                </div>
                <div className="about-contact-grid inner-style">
                  <span className="about-contact-icon">
                    <i className="fa-solid fa-headphones-simple"></i>
                  </span>
                  <div className="about-contact-details">
                    <span className="sec-text">Call Us For Query</span>
                    <p className="about-contact-details-text">
                      <a href="tel:+256698253158" style={{textDecoration:'none'}}>+91 9515663614</a>
                    </p>
                  </div>
                </div>
                <div className="about-contact-grid inner-style">
                  <span className="about-contact-icon">
                    <i className="fa-light fa-envelope-open-text"></i>
                  </span>
                  <div className="about-contact-details">
                    <span className="sec-text">Email Us Anytime</span>
                    <p className="about-contact-details-text">
                      <a href="mailto:info@avighnaespl.com" style={{textDecoration:'none'}}>info@avighnaespl.com</a>
                    </p>
                  </div>
                </div>
                <div className="about-contact-grid inner-style">
                  <span className="about-contact-icon">
                    <i className="fa-thin fa-map-location-dot"></i>
                  </span>
                  <div className="about-contact-details">
                    <span className="sec-text">Visit Our Office</span>
                    <p className="about-contact-details-text">
                      A Block, Ardente Office One,
Hoodi Main Rd, Hoodi,
Bengaluru, Karnataka 560048
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-xl-7">
              <div className="contact-formbox ms-xl-3 ps-xl-3">
                <form
                  action="#"
                  method="POST"
                  className="contact-form ajax-contact"
                >
                  <div className="row">
                    <div className="col-sm-6 form-group">
                      <input type="text" className="form-control" name="name" id="name3" placeholder="Your Name" />
                      <img src="/assets/img/icon/user.svg" alt="" />
                    </div>
                    <div className="col-sm-6 form-group">
                      <input type="email" className="form-control" name="email" id="email" placeholder="Email Address" />
                      <img src="/assets/img/icon/mail.svg" alt="" />
                    </div>
                    <div className="col-sm-6 form-group">
                      <input type="text" className="form-control" name="number" id="number" placeholder="Phone Number" />
                      <img src="/assets/img/icon/call.svg" alt="" />
                    </div>
                    <div className="col-sm-6 form-group">
                      <select name="subject" id="subject" className="form-select">
                        <option value="" disabled selected>Select Subject</option>
                        <option value="Django Development">Django Development</option>
                        <option value="JavaScript Development">JavaScript Development</option>
                        <option value="Uixi Design">Uixi Design</option>
                        <option value="App Development">App Development</option>
                        <option value="Software Management">Software Management</option>
                      </select>
                    </div>
                    <div className="form-group col-12">
                      <textarea
                        name="message"
                        id="message"
                        cols="30"
                        rows="3"
                        className="form-control"
                        placeholder="Your Message"
                      ></textarea>
                      <img src="/assets/img/icon/chat.svg" alt="" />
                    </div>
                    <div className="form-btn col-12">
                      <button type="submit" className="th-btn">
                        Subscribe Now <img src="/assets/img/icon/plane4.svg" alt="" />
                      </button>
                    </div>
                  </div>
                  <p className="form-messages mb-0 mt-3"></p>
                </form>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Map Section */}
      <div className="space-bottom">
        <div className="container">
          <div className="contact-map style2">
           <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7775.341291205501!2d77.71566419999999!3d12.992904999999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae119729f41d8d%3A0x49fc37a26ed23914!2sArdente%20Office%20One!5e0!3m2!1sen!2sin!4v1752750426935!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

            <div className="contact-icon">
              <img src="/assets/img/icon/location-dot3.svg" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contactus;
